import { ref, deleteObject, listAll, getDownloadURL } from "firebase/storage";
import { storage } from "../firebaseService/connection";

export const deleteImageFromStorage = (path) => {
  return new Promise((resolve, reject) => {
    const imageRef = ref(storage, path);

    deleteObject(imageRef)
      .then(() => {
        resolve();
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const listFilesInFolder = (folderPath) => {
  return new Promise((resolve, reject) => {
    const folderRef = ref(storage, folderPath);

    listAll(folderRef)
      .then(async (result) => {
        try {
          const downloadUrls = await Promise.all(
            result.items.map(async (itemRef) => {
              try {
                const url = await getDownloadURL(itemRef);
                return {
                  name: itemRef.name,
                  fullPath: itemRef.fullPath,
                  url: url,
                };
              } catch (error) {
                console.error(
                  `Error getting download URL for ${itemRef.fullPath}:`,
                  error
                );
                return null;
              }
            })
          );

          // Filter out any failed downloads and return file objects
          const validFiles = downloadUrls.filter((item) => item !== null);
          resolve(validFiles);
        } catch (error) {
          reject(error);
        }
      })
      .catch((error) => {
        console.error("Error listing files in folder:", error);
        reject(error);
      });
  });
};
